import PropTypes from "prop-types";
import { FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";

const NORMAL_BORDER_COLOR = "#ddd";
const ERROR_COLOR = "red";

const SelectController = ({
    name,
    options,
    onChange,
    control,
    label,
    rules,
    errors,
    isMulti,
    defaultValue,
    readOnly,
    placeholder = "Seleccionar...",
    disabled,
    zIndex = 10,
    styles,
    customFilter
}) => {
    return (
        <FormGroup className="select-controller">
            {label != null && <Label for={name}>{label}</Label>}
            {control == null ? (
                <Select
                    isMulti={isMulti}
                    styles={{ ...styles, menu: provided => ({ ...provided, zIndex: zIndex }) }}
                    options={options}
                    onChange={onChange}
                    defaultValue={defaultValue ?? []}
                    placeholder={placeholder}
                    filterOption={customFilter}
                />
            ) : (
                <>
                    <Controller
                        name={name}
                        rules={rules}
                        control={control}
                        render={({ field, fieldState: { invalid } }) => {
                            const isValid = !invalid;
                            const customStyles = {
                                ...styles,
                                control: (base, state) => {
                                    const color = state.isFocused
                                        ? NORMAL_BORDER_COLOR
                                        : isValid
                                        ? NORMAL_BORDER_COLOR
                                        : ERROR_COLOR;

                                    return {
                                        ...base,
                                        borderColor: color,
                                        "&:hover": {
                                            borderColor: color,
                                        },
                                        zIndex,
                                    };
                                },
                                menu: provided => ({ ...provided, zIndex: zIndex })
                            };

                            return (
                                <Select
                                    {...field}
                                    placeholder={placeholder}
                                    isDisabled={readOnly || disabled}
                                    isMulti={isMulti}
                                    options={options}
                                    aria-invalid={true}
                                    filterOption={customFilter}
                                    styles={customStyles}
                                    aria-errormessage="error"
                                    onChange={(value) => {
                                        field.onChange(value);
                                        onChange && onChange(value);
                                    }}
                                />
                            );
                        }}
                    />
                    {errors[name] && (
                        <span className="invalid-feedback">
                            {errors[name].message}
                        </span>
                    )}
                </>
            )}
        </FormGroup>
    );
};

SelectController.propTypes = {
    name: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    control: PropTypes.object,
    label: PropTypes.string,
    rules: PropTypes.object,
    errors: PropTypes.object,
    isMulti: PropTypes.bool,
    defaultValue: PropTypes.object,
    readOnly: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    zIndex: PropTypes.number,
    styles: PropTypes.object,
    customFilter: PropTypes.func
};

export default SelectController;
